/* Product add-to-cart, cart confirmation, and curated complements. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const cartSection = 'shopify-section-ombrail-mini-cart';

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-o-direct-purchase]')) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const button = event.submitter || form.querySelector('[name="add"]');
    const status = form.closest('[data-o-product], [data-ms02]')?.querySelector('[data-o-cart-status]');
    if (button) button.disabled = true;
    if (status) { status.hidden = true; status.textContent = ''; }

    try {
      const data = new FormData(form);
      data.set('sections', 'ombrail-mini-cart');
      data.set('sections_url', window.location.pathname);
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', body: data, credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this piece.');

      const section = result.sections?.['ombrail-mini-cart'];
      const current = document.getElementById(cartSection);
      const parsed = section && new DOMParser().parseFromString(section, 'text/html').getElementById(cartSection);
      if (!current || !parsed) { window.location.assign(root + 'cart'); return; }
      current.replaceWith(parsed);
      const count = parsed.querySelector('[data-o-cart-count]')?.dataset.oCartCount;
      if (count !== undefined) {
        document.querySelectorAll('.o-head__cart').forEach((link) => {
          const badge = link.querySelector('b');
          if (badge) badge.textContent = count;
          link.setAttribute('aria-label', (link.getAttribute('aria-label') || 'Cart').replace(/:\s*\d+$/, ': ' + count));
        });
      }
      const dialog = parsed.querySelector('[data-o-mini-cart]');
      dialog?.showModal();
    } catch (error) {
      if (status) { status.textContent = error.message || 'Could not add this piece.'; status.hidden = false; }
    } finally {
      if (button) button.disabled = false;
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-o-mini-cart-close]')) {
      event.target.closest('[data-o-mini-cart]')?.close();
    }
    if (event.target.matches('[data-o-mini-cart]')) event.target.close();
  });

})();
